module.exports = __webpack_public_path__ + "img/collection-engagementRingsRingsets.311bf54.webp";